import React from "react";
import MultipleSelection from "../../../../components/MultipleSelection,";
import { useTranslation } from "../../../../hooks";
import {
  RentResourceBatchWalletStatus,
  RentResourceRequestStatus,
} from "@wallet-manager/node-types/dist/src/postgres/const";

interface IProps {
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  disabled?: boolean;
}

const StatusMultipleSelection = (props: IProps) => {
  const { value, onChange, label, disabled } = props;

  const { t } = useTranslation("tronWalletResourceBalance");

  const enumData = Object.fromEntries(
    Object.entries(RentResourceBatchWalletStatus).filter(
      ([name, value]) => ![5, 6].includes(Number(value))
    )
  );

  return (
    <MultipleSelection
      label={label || t("psStatus")}
      value={value}
      onChange={onChange}
      enumData={enumData}
      disabled={disabled}
      isNoSorting
    />
  );
};

export default StatusMultipleSelection;
